import { render, staticRenderFns } from "./MarketButtons.vue?vue&type=template&id=2561839b&"
import script from "./MarketButtons.vue?vue&type=script&lang=js&"
export * from "./MarketButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports